export enum FieldNames {
  Favorites = 'favorites',
  Sectors = 'sectors',
  Sites = 'sites',
  Equipment = 'equipment',
  Categories = 'categories',
}
